var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6959 3.21829C18.7687 1.63247 16.6668 3.97015 16.6668 3.97015C16.6668 3.97015 14.565 1.63245 11.6377 3.21828C8.22235 5.06855 7.86077 12.1163 15.7314 15.616C16.3252 15.8801 17.0086 15.8801 17.6023 15.616C25.473 12.1163 25.1112 5.06856 21.6959 3.21829Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 18.6667H8.64848C9.09787 18.6667 9.53995 18.7803 9.9337 18.9968L12.6668 20.5001H14.0002C16.0002 20.5001 17.3335 22.032 17.3335 23.3331L13.7551 24.5259C13.4815 24.6171 13.1855 24.6171 12.9119 24.5259L9.3335 23.3331M17.3326 22.6667L22.9472 20.7951C24.2867 20.3487 25.742 21.0236 26.2664 22.3345C26.4922 22.8991 26.2476 23.5425 25.7038 23.8144L15.5902 28.8712C14.9955 29.1685 14.3114 29.2331 13.6716 29.052L5.3335 26.6932",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.3d7a0e31d1c0f4d6592563e0097bd878.svg";
export { ForwardRef as ReactComponent };